import * as types from '../types';

export const setPromoList = arr => ({
  type: types.SET_PROMO_LIST,
  arr
});
